<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import PostSaleTopicSummary from './PostSaleTopicSummary.vue';

defineProps({
  canManage: { type: Boolean, default: false },
  catalog: { type: Object, default: () => ({}) },
  loading: { type: Boolean, default: false },
  topics: { type: Array, default: () => [] },
});

const emit = defineEmits(['delete', 'edit', 'editAnalysis']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    data-testid="post-sale-status-analysis-topics"
    class="h-full w-full max-w-[513px]"
    density="flush"
  >
    <template #header>
      <div class="flex items-center gap-2">
        <span class="i-lucide-list-checks size-5 text-lais-text" />
        <h2
          class="text-xl font-bold leading-6 text-lais-text font-redHatDisplay"
        >
          {{ t('POST_SALE.TOPICS.STATUS_TITLE') }}
        </h2>
      </div>
    </template>

    <div v-if="loading" class="grid gap-3 bg-lais-bg-soft p-4">
      <div
        v-for="index in 3"
        :key="index"
        class="h-14 animate-pulse rounded-lais-sm bg-white"
      />
    </div>
    <div v-else class="bg-lais-bg-soft">
      <div
        v-for="topic in topics"
        :key="topic.id"
        data-testid="post-sale-status-analysis-topic"
      >
        <PostSaleTopicSummary
          :can-manage="canManage"
          :catalog="catalog"
          compact
          :topic="topic"
          @delete="emit('delete', $event)"
          @edit="emit('edit', $event)"
        />
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <LaisPrimaryButton
          v-if="canManage"
          variant="link"
          icon="i-lucide-pencil"
          @click="emit('editAnalysis')"
        >
          {{ t('POST_SALE.TOPICS.ACTIONS.EDIT_FULL') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisCard>
</template>
